module.exports = __webpack_public_path__ + "img/20200330144126TIM截图20200330143940.dd60c47f.png";